import React, {FC} from "react";

import { Link } from "react-router-dom";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

type componentProps = {
  style?:React.CSSProperties | CSS.Properties,
  className?:string,
  children?:React.ReactNode, // | React.ReactElement<any> | React.CSSProperties
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

const routerLink:FC<componentProps> = ({...props}) => {
  const Nstyle = (props.style ? {...props.style} : undefined);
  return (
    <Link {...props} to={props.to || "/"} className={props.className} style={Nstyle} >{props?.children}</Link>
  );
};

export default routerLink;
